import { g as getMongo } from "../../../../../../../../../chunks/mongo.js";
const load = async ({ params }) => {
  const mongo = await getMongo();
  const client = mongo.getClient(params.server);
  const db = client.db(params.database);
  const mappings = await client.getMappings(params.database, params.collection, { forceRefresh: true });
  const allCollections = (await db.listCollections().toArray()).map((c) => c.name).sort();
  return {
    mappings,
    availableCollections: allCollections
  };
};
export {
  load
};
